<svg width="17" height="16" viewBox="0 0 17 16" fill="#000000"
  xmlns="http://www.w3.org/2000/svg">
  <path d="M13.002 16H2.00195C0.897383 16 0.00195312 15.1046 0.00195312 14V3C0.00195312 1.89543 0.897383 1 2.00195 1H6.00195V3H2.00195V14H13.002V10H15.002V14C15.002 15.1046 14.1065 16 13.002 16ZM7.70195 9.707L6.29195 8.293L12.585 2H9.00195V0H16.002V7H14.002V3.415L7.70195 9.707Z" fill="currentColor" />
</svg>
